import { createRoot } from 'react-dom/client'
import { ProductAddToCart } from './ProductAddToCart'

const selector = '.site-panel--product form.cart'

function mountProductForm(form) {
  if (form.__novaProductReactRoot) {
    return
  }

  const mount = document.createElement('div')
  mount.className = 'nova-product-add-to-cart-react'
  form.insertAdjacentElement('afterend', mount)

  form.__novaProductReactRoot = createRoot(mount)
  form.__novaProductReactRoot.render(
    <ProductAddToCart form={form} config={window.novaThemeReactProductPage || {}} />,
  )
}

function mountProductForms(root = document) {
  if (root.matches?.(selector)) {
    mountProductForm(root)
  }

  root.querySelectorAll?.(selector).forEach(mountProductForm)
}

mountProductForms()

new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE) {
        mountProductForms(node)
      }
    })
  })
}).observe(document.documentElement, { childList: true, subtree: true })
